import Swal from 'sweetalert2'

export function useOk(message = null, icon = null) {
	return Swal.fire({
		icon,
		title: message,
		customClass: {
			container: 'themed ok',
		},
	})
}
